export class ACTIV {
    Type: string = "ACTIV";
    SerialNumber: string;
    Active: boolean;
    StatusPiece : number;
}